import { render, staticRenderFns } from "./user-box.vue?vue&type=template&id=0615c612&scoped=true&"
import script from "./user-box.vue?vue&type=script&lang=js&"
export * from "./user-box.vue?vue&type=script&lang=js&"
import style0 from "./user-box.vue?vue&type=style&index=0&id=0615c612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0615c612",
  null
  
)

export default component.exports